export enum RoleEnum {
    ADMIN = "admin",
    SUPERVISOR = "bcba",
    INSTRUCTOR = "para",
    STUDENT = "patient",
    GUARDIAN = "guardian"
}